/* eslint-disable max-lines */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDeliveryDetails: {},
  deliveryDates: {},
  shippingDetails: {},
  loading: true,
  isDeliveryDatesLoading: false,
  isShippingLoaded: false,
  errorMsg: {},
  blockedDates: {},
  shippingAndTimeSlot: {},
  updatedDeliveryDatesAndGeoPrice: {},
  internationalDeliveryMethods: {},
  internationalTimeSlotsByDate: {},
  internationalDeliveryDates: {},
  multiProductDateRange: [],
  nextAvailableDifference: {},
  checkoutCombinedShippingResponse: {},
};

export const ShippingDateAndSlotSelectionSlice = createSlice({
  name: "ShippingDateAndSlotSelection",
  initialState,
  reducers: {
    requestToFetchDeliveryDatesAction: (state) => {
      return {
        ...state,
        loading: true,
        isDeliveryDatesLoading: true,
      };
    },
    successToFetchDeliveryDatesAction: (state, action) => {
      return {
        ...state,
        ...action.payload,
        isShippingLoaded: true,
        loading: false,
        isDeliveryDatesLoading: false,
      };
    },
    failToFetchDeliveryDatesAction: (state, action) => {
      return {
        ...state,
        loading: false,
        isDeliveryDatesLoading: false,
        deliveryDates: {},
        shippingDetails: {},
        errorMsg: action.payload,
      };
    },

    requestToFetchBlockedDatesAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchBlockedDatesAction: (state, action) => {
      return {
        ...state,
        loading: false,
        isShippingLoaded: true,
        blockedDates: action.payload,
      };
    },

    requestToFetchShippingAndTimeSlotAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchShippingAndTimeSlotAction: (state, action) => {
      return {
        ...state,
        loading: false,
        shippingAndTimeSlot: action.payload,
        isShippingLoaded: true,
      };
    },
    failToFetchShippingAndTimeSlotAction: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },
    successToFetchCombinedCheckoutShippingAction: (state, action) => {
      return {
        ...state,
        loading: false,
        checkoutCombinedShippingResponse: action.payload,
        isShippingLoaded: true,
      };
    },
    clearCombinedCheckoutShippingAction: (state) => {
      return {
        ...state,
        checkoutCombinedShippingResponse: {},
      };
    },
    setProductDeliveryShippingDetailsAction: (state, action) => {
      return {
        ...state,
        deliveryDates: action?.payload?.deliveryDates,
        shippingDetails: action?.payload?.shippingDetails,
        nextAvailableDifference: action?.payload?.nextAvailableDifference,
        earliestTimeSlot: action?.payload?.earliestTimeSlot,
        instantDeliveryWindow: action?.payload?.instantDeliveryWindow,
        isInstant: action?.payload?.isInstant,
        loading: false,
      };
    },
    setDeliveryDetailsAction: (state, action) => {
      return {
        ...state,
        selectedDeliveryDetails: action.payload,
      };
    },
    clearDeliveryDetailsAction: (state) => {
      return {
        ...state,
        selectedDeliveryDetails: {},
      };
    },
    requestToFetchGetDeliveryDateAndGeoPriceAction: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchGetDeliveryDateAndGeoPriceAction: (state, action) => {
      return {
        ...state,
        loading: false,
        updatedDeliveryDatesAndGeoPrice: action.payload,
      };
    },
    failToFetchGetDeliveryDateAndGeoPriceAction: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },
    resetGetDeliveryDateAndGeoPriceAction: (state) => {
      return {
        ...state,
        updatedDeliveryDatesAndGeoPrice: {},
      };
    },
    requestToFetchInternationalShippingMethod: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    responseFromInternationalShippingMethod: (state, action) => {
      return {
        ...state,
        loading: false,
        internationalDeliveryMethods: action.payload,
      };
    },
    clearOldInternationalShippingMethod: (state) => {
      return {
        ...state,
        internationalDeliveryMethods: {},
      };
    },

    requestToFetchInternationalShippingAndTimeSlot: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchInternationalShippingAndTimeSlot: (state, action) => {
      return {
        ...state,
        loading: false,
        internationalTimeSlotsByDate: action.payload,
      };
    },
    failToFetchInternationalShippingAndTimeSlot: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },

    requestToFetchInternationalDeliveryDates: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    responseFromInternationalDeliveryDates: (state, action) => {
      return {
        ...state,
        loading: false,
        internationalDeliveryDates: action.payload,
      };
    },
    setMultiProductDateRange: (state, action) => {
      return {
        ...state,
        multiProductDateRange: action.payload,
      };
    },
    resetMultiProductDateRange: (state) => {
      return {
        ...state,
        multiProductDateRange: [],
      };
    },
    resetShippingLoader: (state) => {
      return {
        ...state,
        isShippingLoaded: false,
      };
    },
    requestToFetchEarliestTimeSlot: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    successToFetchEarliestTimeSlotDetailsAction: (state, action) => {
      return {
        ...state,
        loading: false,
        earliestTimeSlot: action.payload,
      };
    },
    failToFetchEarliestTimeSlotDetailsAction: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMsg: action.payload,
      };
    },
    requestResetShippingDateAndSlot: () => initialState,
  },
});

export default ShippingDateAndSlotSelectionSlice.reducer;
export const {
  requestToFetchDeliveryDatesAction,
  successToFetchDeliveryDatesAction,
  failToFetchDeliveryDatesAction,
  requestToFetchBlockedDatesAction,
  successToFetchBlockedDatesAction,
  requestToFetchShippingAndTimeSlotAction,
  successToFetchShippingAndTimeSlotAction,
  failToFetchShippingAndTimeSlotAction,
  successToFetchCombinedCheckoutShippingAction,
  clearCombinedCheckoutShippingAction,
  setDeliveryDetailsAction,
  setProductDeliveryShippingDetailsAction,
  requestToFetchGetDeliveryDateAndGeoPriceAction,
  successToFetchGetDeliveryDateAndGeoPriceAction,
  failToFetchGetDeliveryDateAndGeoPriceAction,
  resetGetDeliveryDateAndGeoPriceAction,
  requestToFetchInternationalDeliveryDates,
  responseFromInternationalDeliveryDates,
  requestToFetchInternationalShippingMethod,
  responseFromInternationalShippingMethod,
  clearOldInternationalShippingMethod,
  requestToFetchInternationalShippingAndTimeSlot,
  successToFetchInternationalShippingAndTimeSlot,
  failToFetchInternationalShippingAndTimeSlot,
  setMultiProductDateRange,
  resetMultiProductDateRange,
  clearDeliveryDetailsAction,
  resetShippingLoader,
  requestToFetchEarliestTimeSlot,
  successToFetchEarliestTimeSlotDetailsAction,
  failToFetchEarliestTimeSlotDetailsAction,
  requestResetShippingDateAndSlot,
} = ShippingDateAndSlotSelectionSlice.actions;
